var map = {
	"./capture-photo/acceptable.jpg": 8702,
	"./capture-photo/background-object.png": 3780,
	"./capture-photo/background-textured.png": 3350,
	"./capture-photo/harsh.png": 7052,
	"./capture-photo/shadow.png": 2370,
	"./common/processing-spinner.gif": 9852,
	"./dvla-common-customer/A.png": 3214,
	"./dvla-common-customer/AM.png": 3241,
	"./dvla-common-customer/B.png": 1365,
	"./dvla-common-customer/B1.png": 9816,
	"./dvla-common-customer/BE.png": 6988,
	"./dvla-common-customer/C.png": 1948,
	"./dvla-common-customer/C1.png": 1631,
	"./dvla-common-customer/C1E.png": 4338,
	"./dvla-common-customer/CE.png": 6475,
	"./dvla-common-customer/D.png": 5555,
	"./dvla-common-customer/D1.png": 8818,
	"./dvla-common-customer/D1E.png": 8357,
	"./dvla-common-customer/DE.png": 7574,
	"./dvla-common-customer/pdf-icon.png": 7115,
	"./govuk/fonts/bold-affa96571d-v2.woff": 6152,
	"./govuk/fonts/bold-b542beb274-v2.woff2": 1487,
	"./govuk/fonts/light-94a07e06a1-v2.woff2": 889,
	"./govuk/fonts/light-f591b13f7d-v2.woff": 2997,
	"./govuk/images/favicon.ico": 2172,
	"./govuk/images/favicon.svg": 4729,
	"./govuk/images/govuk-crest.svg": 5791,
	"./govuk/images/govuk-icon-180.png": 400,
	"./govuk/images/govuk-icon-192.png": 4905,
	"./govuk/images/govuk-icon-512.png": 2437,
	"./govuk/images/govuk-icon-mask.svg": 3714,
	"./govuk/images/govuk-opengraph-image.png": 3609,
	"./govuk/manifest.json": 1788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5711;